import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="grid gap-6 sm:grid-cols-2">
      <Card title="Öğrenci Analiz" to="/ogrenci-analiz" description="Öğrenciyi arayın, seçtiğiniz ders(ler) için zaman içinde not grafiğini görün. Sınıf ve okul ortalaması çizgileri ile kıyaslayın." />
      <Card title="Ders Analiz" to="/ders-analiz" description="Okul, sınıf düzeyi veya şube için seçilen ders(ler) başarısını zaman içinde izleyin." />
    </div>
  );
}

function Card({ title, description, to }: { title: string; description: string; to: string }) {
  return (
    <Link to={to} className="block rounded-xl border bg-white p-6 shadow-sm hover:shadow-md transition-shadow">
      <div className="text-lg font-semibold text-slate-800">{title}</div>
      <p className="mt-2 text-sm text-slate-600">{description}</p>
    </Link>
  );
}


